var map = {
	"./blue-sky-background.jpg": "904d",
	"./character-a.png": "d09f",
	"./character-b.png": "ec7a",
	"./character-c.png": "b98c",
	"./character-d.png": "9160",
	"./clock-border.svg": "b39f",
	"./cloud-1.png": "bbbb",
	"./cloud-2.png": "0c2b",
	"./cloud-background-top.png": "15f0",
	"./cloud-background.png": "04b9",
	"./down-arrow.png": "ab9f",
	"./favicon.png": "8925e",
	"./future-news-logo.svg": "90e3c",
	"./hot-air-1.png": "9f7f",
	"./hot-air-2.png": "5017",
	"./live-text.png": "c06f",
	"./live-text.svg": "0316",
	"./our-world-logo-colour.png": "53d8",
	"./our-world-logo-white.svg": "4d2b",
	"./sun.png": "5dd5",
	"./sunshine-background.jpg": "1052",
	"./sunshine-background.png": "916a",
	"./up-arrow.png": "26ab",
	"./world-background.svg": "f595"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";